export { GuildGeogatedBenefitsPrompt } from './GuildGeogatedBenefitsPrompt'
